import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, TrendingUp, Users, Target, Zap } from 'lucide-react';
import { AreaChart, Area, ResponsiveContainer, Tooltip, XAxis } from 'recharts';
const data = [{
  name: 'Ene',
  value: 400
}, {
  name: 'Feb',
  value: 800
}, {
  name: 'Mar',
  value: 1200
}, {
  name: 'Abr',
  value: 2100
}, {
  name: 'May',
  value: 3500
}, {
  name: 'Jun',
  value: 4800
}];
export function Hero() {
  return <section id="hero" className="relative pt-32 pb-20 lg:pt-48 lg:pb-32 overflow-hidden bg-gradient-to-b from-brand-cyan/10 via-white to-white" data-id="element-112">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10" data-id="element-113">
        <div className="absolute top-[-10%] right-[-5%] w-[600px] h-[600px] rounded-full bg-brand-cyan/20 blur-[120px]" data-id="element-114" />
        <div className="absolute bottom-[-10%] left-[-10%] w-[600px] h-[600px] rounded-full bg-brand-cyan/10 blur-[120px]" data-id="element-115" />
        {/* Grid pattern */}
        <div className="absolute inset-0 bg-[linear-gradient(to_right,#00C8D715_1px,transparent_1px),linear-gradient(to_bottom,#00C8D715_1px,transparent_1px)] bg-[size:24px_24px]" data-id="element-116" />
      </div>

      <div className="container mx-auto px-6 md:px-12" data-id="element-117">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-118">
          {/* Left Content */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="max-w-2xl" data-id="element-119">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-brand-cyanLight text-brand-cyan text-sm font-semibold mb-6 border border-brand-cyan/20" data-id="element-120">
              <Zap size={14} className="fill-brand-cyan" data-id="element-121" />
              <span data-id="element-122">Agencia de Crecimiento Digital</span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-[1.1] tracking-tight mb-6" data-id="element-123">
              Atraemos Más Clientes y{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-black to-brand-cyan" data-id="element-124">
                Automatizamos
              </span>{' '}
              Tu Crecimiento
            </h1>

            <p className="text-lg md:text-xl text-slate-600 mb-10 leading-relaxed" data-id="element-125">
              Ayudamos empresas a vender más utilizando Google Ads, Inteligencia
              Artificial, CRM y automatización avanzada.
            </p>

            <div className="flex flex-col sm:flex-row gap-4" data-id="element-126">
              <a href="#contacto" className="inline-flex items-center justify-center gap-2 bg-brand-black text-white px-8 py-4 rounded-full font-semibold hover:bg-brand-cyan transition-all duration-300 shadow-lg hover:shadow-glow group" data-id="element-127">
                Solicitar Diagnóstico Gratuito
                <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" data-id="element-128" />
              </a>
              <a href="#contacto" className="inline-flex items-center justify-center bg-white text-brand-black border border-slate-200 px-8 py-4 rounded-full font-semibold hover:border-brand-black hover:bg-slate-50 transition-all duration-300" data-id="element-129">
                Agendar Reunión
              </a>
            </div>
          </motion.div>

          {/* Right Content - Dashboard Mockup */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative" data-id="element-130">
            {/* Main Dashboard Card */}
            <div className="bg-white rounded-2xl shadow-card border border-slate-100 p-6 relative z-10" data-id="element-131">
              <div className="flex items-center justify-between mb-8 pb-4 border-b border-slate-50" data-id="element-132">
                <div data-id="element-133">
                  <h3 className="font-montserrat font-bold text-lg" data-id="element-134">
                    Crecimiento de Ventas
                  </h3>
                  <p className="text-sm text-slate-500" data-id="element-135">Últimos 6 meses</p>
                </div>
                <div className="bg-green-100 text-green-700 px-3 py-1 rounded-full text-sm font-semibold flex items-center gap-1" data-id="element-136">
                  <TrendingUp size={14} data-id="element-137" /> +124%
                </div>
              </div>

              <div className="h-[200px] w-full mb-6" data-id="element-138">
                <ResponsiveContainer width="100%" height="100%" data-id="element-139">
                  <AreaChart data={data} data-id="element-140">
                    <defs data-id="element-141">
                      <linearGradient id="colorValue" x1="0" y1="0" x2="0" y2="1" data-id="element-142">
                        <stop offset="5%" stopColor="#00C8D7" stopOpacity={0.3} data-id="element-143" />
                        <stop offset="95%" stopColor="#00C8D7" stopOpacity={0} data-id="element-144" />
                      </linearGradient>
                    </defs>
                    <Tooltip contentStyle={{
                    borderRadius: '8px',
                    border: 'none',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
                  }} labelStyle={{
                    color: '#64748b'
                  }} data-id="element-145" />
                    <Area type="monotone" dataKey="value" stroke="#00C8D7" strokeWidth={3} fillOpacity={1} fill="url(#colorValue)" data-id="element-146" />
                  </AreaChart>
                </ResponsiveContainer>
              </div>

              <div className="grid grid-cols-2 gap-4" data-id="element-147">
                <div className="bg-slate-50 rounded-xl p-4 border border-slate-100" data-id="element-148">
                  <div className="flex items-center gap-2 text-slate-500 text-sm mb-2" data-id="element-149">
                    <Target size={16} className="text-brand-cyan" data-id="element-150" /> Google Ads
                  </div>
                  <div className="font-bold text-xl" data-id="element-151">12.4K</div>
                  <div className="text-xs text-green-600 mt-1" data-id="element-152">
                    +24% vs mes anterior
                  </div>
                </div>
                <div className="bg-slate-50 rounded-xl p-4 border border-slate-100" data-id="element-153">
                  <div className="flex items-center gap-2 text-slate-500 text-sm mb-2" data-id="element-154">
                    <Users size={16} className="text-brand-cyan" data-id="element-155" /> CRM Leads
                  </div>
                  <div className="font-bold text-xl" data-id="element-156">3,842</div>
                  <div className="text-xs text-green-600 mt-1" data-id="element-157">
                    +18% vs mes anterior
                  </div>
                </div>
              </div>
            </div>

            {/* Floating Chips */}
            <motion.div animate={{
            y: [0, -10, 0]
          }} transition={{
            duration: 4,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="absolute -top-6 -right-6 bg-white px-4 py-3 rounded-xl shadow-glass border border-slate-100 flex items-center gap-3 z-20" data-id="element-158">
              <div className="w-8 h-8 rounded-full bg-brand-cyan/10 flex items-center justify-center text-brand-cyan" data-id="element-159">
                <Users size={16} data-id="element-160" />
              </div>
              <div data-id="element-161">
                <div className="text-xs text-slate-500" data-id="element-162">Nuevos Leads</div>
                <div className="font-bold text-brand-black" data-id="element-163">+287%</div>
              </div>
            </motion.div>

            <motion.div animate={{
            y: [0, 10, 0]
          }} transition={{
            duration: 5,
            repeat: Infinity,
            ease: 'easeInOut',
            delay: 1
          }} className="absolute top-1/2 -left-12 bg-white px-4 py-3 rounded-xl shadow-glass border border-slate-100 flex items-center gap-3 z-20" data-id="element-164">
              <div className="w-8 h-8 rounded-full bg-green-100 flex items-center justify-center text-green-600" data-id="element-165">
                <TrendingUp size={16} data-id="element-166" />
              </div>
              <div data-id="element-167">
                <div className="text-xs text-slate-500" data-id="element-168">ROAS</div>
                <div className="font-bold text-brand-black" data-id="element-169">+4.8X</div>
              </div>
            </motion.div>

            <motion.div animate={{
            y: [0, -8, 0]
          }} transition={{
            duration: 4.5,
            repeat: Infinity,
            ease: 'easeInOut',
            delay: 2
          }} className="absolute -bottom-6 right-10 bg-white px-4 py-3 rounded-xl shadow-glass border border-slate-100 flex items-center gap-3 z-20" data-id="element-170">
              <div className="w-8 h-8 rounded-full bg-brand-black flex items-center justify-center text-white" data-id="element-171">
                <Target size={16} data-id="element-172" />
              </div>
              <div data-id="element-173">
                <div className="text-xs text-slate-500" data-id="element-174">CPA</div>
                <div className="font-bold text-brand-black" data-id="element-175">-42%</div>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>;
}